import { COLOR_CSS_VAR_NAME_CONFIG } from './css-var-name-config'

export const OWN_COLOR: Record<
  string,
  {
    h: number
    s: number
    l: {
      default: number
      [extraOwnShade: string]: number
    }
  }
> = {
  black: {
    h: 0,
    s: 0,
    l: {
      default: 0,
    },
  },
  white: {
    h: 0,
    s: 0,
    l: {
      default: 100,
    },
  },
  brand: (() => {
    return {
      h: 212,
      s: 86,
      l: {
        'fill-pressed': 36,
        'fill-hover': 41,
        'default': 46,
        '60': 60,
        'stroke-primary': 81,
        'fill-primary': 97,
        '98': 98,
        '99': 99,
      },
    }
  })(),
  neutral: (() => {
    return {
      h: 214,
      s: 18,
      l: {
        'default': 16,
        'text-icons-secondary': 39,
        'text-icons-disabled': 77,
        'fill-text-dividers-stroke-disabled': 93,
        'fill-background-secondary': 97,
        'fill-surface-primary': 100,
      },
    }
  })(),
  danger: (() => {
    return {
      h: 0,
      s: 92,
      l: {
        'default': 60,
        'fill-stroke-secondary': 94,
      },
    }
  })(),
  success: (() => {
    return {
      h: 139,
      s: 57,
      l: {
        'default': 40,
        'fill-stroke-secondary': 91,
      },
    }
  })(),
  warning: (() => {
    return {
      h: 40,
      s: 90,
      l: {
        'default': 52,
        'fill-stroke-secondary': 93,
      },
    }
  })(),
}

const constructOwnColorHslCoords = (ownColorGroupName: string): React.CSSProperties => {
  const varNameBase = COLOR_CSS_VAR_NAME_CONFIG.own

  const hue = OWN_COLOR[ownColorGroupName].h
  const saturation = OWN_COLOR[ownColorGroupName].s

  const hueDecl = {
    [`${varNameBase}-h-${ownColorGroupName}`]: `${hue}deg`,
  }
  const saturationDecl = {
    [`${varNameBase}-s-${ownColorGroupName}`]: `${saturation}%`,
  }

  const lightnessShadeEntries = Object.entries(OWN_COLOR[ownColorGroupName].l)
  const lightnessDeclEntries = lightnessShadeEntries.map(([shadeName, shadeLightness]) => {
    const varName = `${varNameBase}-l-${ownColorGroupName}-${shadeName}`
    const varValue = `${shadeLightness}%`
    return [varName, varValue]
  })

  return {
    ...hueDecl,
    ...saturationDecl,
    ...Object.fromEntries(lightnessDeclEntries),
  }
}

const getOwnHslColorInlineStyles = (): React.CSSProperties => {
  const ownGroupEntries = Object.entries(OWN_COLOR)
  const ownGroupStyleDecls = ownGroupEntries.map(([ownGroupName]) => {
    return constructOwnColorHslCoords(ownGroupName)
  })

  return ownGroupStyleDecls.reduce((output, styleDecl) => {
    return {
      ...output,
      ...styleDecl,
    }
  }, {})
}

export const ownColorInlineStyles = {
  getHsl: getOwnHslColorInlineStyles,
}
